import $ from 'jquery';

import './load-image';

$(document).ready(() => {
  $('body').attr('ontouchstart', '');
});

$(window).on('load', () => {
  $('.js-lazy-instant').loadImage();
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/base/base.js